import React, { useState } from 'react';
import { profileLinks } from '../../utils/constant';
import { useLocation, useNavigate } from 'react-router-dom';
import { BackButton, RightIcon } from '../ui/UtilsLayout';
import { iconsPath } from '../../utils/imagePath';

const ProfileSidebar = React.memo(({ className, close }) => {
  const [open, setOpen] = useState({});

  const location = useLocation();
  const navigate = useNavigate();
  const handleClose = () => {
    if (close) {
      close();
    }
    setOpen({});
  };

  return (
    <div
      className={`h-[calc(100vh-68px)] min-h-full overflow-auto bg-[#1e1f22]  relative z-[9] flex flex-col shadow-md shadow-[rgba(0,0,0,0.4)] justify-between  md:pr-4 ${className}`}
    >
      {/* Navigation Links */}
      <div className="flex flex-col gap-2 p-3">
        <BackButton
          className={'flex text-white pl-2 mb-4'}
          // icon={<FaChevronLeft size={16} fontWeight={300} />}
          icon={
            <img
              src={iconsPath.leftIcon}
              alt="menu icon"
              className="h-[15px] w-[15px] cursor-pointer"
            />
          }
        />
        {profileLinks.map((item, index) => {
          const isActive = location.pathname === item.link;

          return (
            <div key={index}>
              {/* Main Menu Item */}
              <div
                className={`flex items-center justify-between gap-6 px-4 py-1 rounded-md cursor-pointer text-xl transition-all duration-300
                ${
                  isActive
                    ? 'bg-[#333334] text-white'
                    : 'text-[#979797] hover:bg-[#333334] hover:text-white'
                }
                `}
                onClick={() => {
                  navigate(item.link);
                  handleClose();
                }}
              >
                <div className="flex items-center gap-4 py-1">
                  {item.icon && (
                    <img
                      className="h-[16px] w-[16px] text-[#979797]"
                      src={item.icon}
                      alt={item.name}
                    />
                  )}

                  <span className="text-sm font-medium">{item.name}</span>
                </div>

                {/* Check if submenu exists */}
                {item?.submenu && (
                  <RightIcon
                    className="block lg:hidden"
                    open={open[item.name]}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default ProfileSidebar;
